<template>
  <main class="p-10">
    <h1 class="text-2xl">
      Oops. This Page Doesn't Exist, Sorry!
    </h1>
  </main>
</template>

<script>
export default {
  name: "FourOhFour"
}
</script>

<style scoped>

</style>